document.addEventListener('DOMContentLoaded', function () {
    var iconContentElements = document.querySelectorAll('.collapsible-trigger-btn');
    console.log(iconContentElements);
    var collapsibleContentElements = document.querySelectorAll('.collapsible-content');
    if (window.innerWidth <= 991) {
        collapsibleContentElements.forEach(function (collapsibleContent, index) {
            // Check if the current element is not the last one
            if (index < collapsibleContentElements.length - 1) {
              collapsibleContent.classList.add('hide');
            }
          });
          iconContentElements.forEach(function (iconContentElementsContent, index) {
            // Check if the current element is not the last one
            if (index < iconContentElements.length - 1) {
                iconContentElementsContent.classList.add('close-sec');
            } else {
                iconContentElementsContent.classList.add('open-sec');
            }
          });
    }else {
        collapsibleContentElements.forEach(function (collapsibleContent) {
            collapsibleContent.classList.remove('hide');
          });
    }
    // Get all buttons and ul elements within grid__item
    var buttons = document.querySelectorAll('.collapsible-trigger-btn');
   
      
    // Add click event listener to each button
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        // Find the closest parent grid__item
        if (button.classList.contains('open-sec')) {
            button.classList.remove('open-sec');
        }else {
            button.classList.add('open-sec');
        }
        var gridItem = button.closest('.grid__item');
        // Find the related ul element based on the button's aria-controls attribute within the grid__item
        var targetId = button.getAttribute('aria-controls');
        var ulElement = gridItem.querySelector('#' + targetId);

        // Toggle the 'hide' class on the ul element
        if (ulElement) {
          ulElement.classList.toggle('hide');
        }
      });
    });
    

    // $('.button-toggle.show').click(function () {
    //   console.log('dsfsfs');
    //   $(this).find('.child-links').toggleClass('child-links-open');
    // });
    $('.parent-menu.has-children').click(function (event) {
      if ($(this).hasClass('active')) {
        $('.parent-menu').removeClass('active');
        $(this).find('.child-links').removeClass('child-links-open');
        $(this).find('.button-toggle').removeClass('show');
      console.log('method');
    }else {
        event.preventDefault();
        $('.parent-menu').removeClass('active');
        $(this).addClass('active');
        $(this).find('.child-links').toggleClass('child-links-open');
        $(this).find('.button-toggle').toggleClass('show');
    }
     
      
      // Remove the 'active' class from all parent menus
     
  });
  });